import React, { useEffect } from "react";

export default function MobileMenuDrawer({
  open,
  onClose,
  onOpenAuth,
  onSelectMenuItem,
  isLoggedIn,
  onLogout,
}) {
  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") onClose?.();
    }
    if (!open) return undefined;
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const items = ["Home", "About", "Subscription", "Grocery List", "How it Works", "Contact", "Privacy Policy", "Terms & Conditions"];

  return (
    <div className="fixed inset-0 z-50">
      <button
        type="button"
        aria-label="Close menu"
        onClick={onClose}
        className="absolute inset-0 bg-black/25"
      />

      <aside className="absolute right-0 top-0 h-full w-[306px] rounded-l-3xl bg-white shadow-2xl border-l border-[#E6EAF0]">
        <div className="flex items-center justify-end px-4 py-3">
          <button
            type="button"
            onClick={onClose}
            className="inline-flex h-11 w-11 items-center justify-center rounded-full p-0 text-slate-600 hover:bg-[#F5F7FB] ring-1 ring-[#E6EAF0]"
            aria-label="Close"
          >
            ✕
          </button>
        </div>

        <nav className="text-[16px] text-[#1E293B] bg-[#FFFFFF]">
          <ul className="space-y-3">
            {items.map((label) => (
              <li key={label}>
                <button
                  type="button"
                  className="w-full border-b-2 border-[#E6EAF0] py-2 px-6 text-left text-[#24303A] font-medium "
                  onClick={() => {
                    onSelectMenuItem?.(label.toLowerCase());
                    onClose?.();
                  }}
                >
                  {label}
                </button>
              </li>
            ))}
          </ul>

          <div className="my-8 bg-[#E6EAF0]" />

          <div className="space-y-4 mx-4">
            {isLoggedIn ? (
              <button
                type="button"
                className="w-full rounded-full border-2 border-femty-primary bg-femty-primary py-1.5 text-[16px] font-bold text-white hover:bg-femty-primary-hover"
                onClick={() => {
                  onLogout?.();
                }}
              >
                Logout
              </button>
            ) : (
              <>
                <button
                  type="button"
                  className="w-full rounded-full border-2 border-[#E6EAF0] bg-white shadow-md py-1.5 text-[16px] font-bold text-femty-text hover:border-femty-primary hover:text-femty-primary"
                  onClick={() => {
                    onClose?.();
                    onOpenAuth?.("login");
                  }}
                >
                  Sign in
                </button>
                <button
                  type="button"
                  className="w-full rounded-full border-2 border-femty-primary bg-femty-primary py-1.5 text-[16px] font-bold text-white hover:bg-femty-primary-hover"
                  onClick={() => {
                    onClose?.();
                    onOpenAuth?.("signup");
                  }}
                >
                  Sign up
                </button>
              </>
            )}
          </div>
        </nav>
      </aside>
    </div>
  );
}

